{
  "level": "in03",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:in03",
    "objects": "AREAS.E3:in03.e3",
    "mesh": "TREES.E3:in03.e3"
  },
  "spawn_point": {
    "position": [
      -3742.0769653320312,
      -4841.897304534912,
      892.9754028320312
    ],
    "facing_rad": 0.0,
    "look_point": [
      -3742.0769653320312,
      -4741.897304534912,
      892.9754028320312
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -4461.83984375,
      -5226.77197265625,
      868.9754028320312
    ],
    "bbox_max": [
      -3203.56298828125,
      -3491.62255859375,
      1027.0509033203125
    ],
    "vertex_count": 64,
    "vertices": [
      [
        -4351.76171875,
        -3491.62255859375,
        1027.0509033203125
      ],
      [
        -4351.71923828125,
        -3491.641357421875,
        994.845703125
      ],
      [
        -4411.8330078125,
        -5031.62060546875,
        945.2203369140625
      ],
      [
        -4411.8330078125,
        -5031.62060546875,
        945.2203369140625
      ],
      [
        -4410.73193359375,
        -5035.68115234375,
        944.7672119140625
      ],
      [
        -4461.302734375,
        -4846.80712890625,
        996.8483276367188
      ],
      [
        -4461.83984375,
        -4844.7685546875,
        997.0745849609375
      ],
      [
        -4461.302734375,
        -4846.80712890625,
        996.8483276367188
      ],
      [
        -4441.07177734375,
        -4855.658203125,
        1001.9581298828125
      ],
      [
        -4443.82861328125,
        -4844.7685546875,
        1003.150146484375
      ],
      [
        -4441.07177734375,
        -4855.658203125,
        1001.9581298828125
      ],
      [
        -4400.10400390625,
        -5029.544921875,
        934.9754028320312
      ],
      [
        -4270.9365234375,
        -5175.2490234375,
        904.52001953125
      ],
      [
        -4407.65380859375,
        -5038.619140625,
        976.2511596679688
      ],
      [
        -4410.61376953125,
        -5035.61279296875,
        977.1580810546875
      ],
      [
        -4407.65380859375,
        -5038.619140625,
        976.2511596679688
      ],
      [
        -4379.5068359375,
        -5041.34521484375,
        978.1266479492188
      ],
      [
        -4393.97412109375,
        -5026.005859375,
        982.6010131835938
      ],
      [
        -4379.5068359375,
        -5041.34521484375,
        978.1266479492188
      ],
      [
        -4080.2314453125,
        -5226.76318359375,
        884.7680053710938
      ],
      [
        -4269.07177734375,
        -5176.1240234375,
        936.8473510742188
      ],
      [
        -4271.11962890625,
        -5175.56640625,
        937.0751342773438
      ],
      [
        -4269.07177734375,
        -5176.1240234375,
        936.8473510742188
      ],
      [
        -4251.30908203125,
        -5163.02587890625,
        941.9586181640625
      ],
      [
        -4262.11474609375,
        -5159.96923828125,
        943.1503295898438
      ],
      [
        -4251.30908203125,
        -5163.02587890625,
        941.9586181640625
      ],
      [
        -3394.884033203125,
        -5175.79296875,
        931.0772705078125
      ],
      [
        -3581.894287109375,
        -5225.734375,
        879.2132568359375
      ],
      [
        -3581.894287109375,
        -5225.734375,
        879.2132568359375
      ],
      [
        -3585.83154296875,
        -5226.77197265625,
        878.775146484375
      ],
      [
        -3574.171142578125,
        -5211.4755859375,
        870.271240234375
      ],
      [
        -3574.171142578125,
        -5211.4755859375,
        870.271240234375
      ],
      [
        -3585.83154296875,
        -5214.49853515625,
        868.9754028320312
      ],
      [
        -3585.83154296875,
        -5192.486328125,
        880.0966186523438
      ],
      [
        -3255.12890625,
        -5036.06494140625,
        961.1178588867188
      ],
      [
        -3390.65771484375,
        -5171.33984375,
        899.6361694335938
      ],
      [
        -3390.65771484375,
        -5171.33984375,
        899.6361694335938
      ],
      [
        -3394.986328125,
        -5175.61572265625,
        898.6530151367188
      ],
      [
        -3396.450439453125,
        -5146.11474609375,
        892.0765991210938
      ],
      [
        -3396.450439453125,
        -5146.11474609375,
        892.0765991210938
      ],
      [
        -3406.4169921875,
        -5155.81689453125,
        889.9071044921875
      ],
      [
        -3203.914794921875,
        -4845.2314453125,
        995.1348876953125
      ],
      [
        -3253.44482421875,
        -5029.37060546875,
        929.8607788085938
      ],
      [
        -3253.44482421875,
        -5029.37060546875,
        929.8607788085938
      ],
      [
        -3255.26611328125,
        -5035.9853515625,
        928.603759765625
      ],
      [
        -3270.890380859375,
        -5009.4990234375,
        922.80224609375
      ],
      [
        -3270.890380859375,
        -5009.4990234375,
        922.80224609375
      ],
      [
        -3275.158203125,
        -5024.5009765625,
        920.0466918945312
      ],
      [
        -3203.56298828125,
        -4331.0,
        1012.75
      ],
      [
        -3204.79736328125,
        -4331.0,
        1012.75
      ],
      [
        -3204.79736328125,
        -4340.0,
        1012.75
      ],
      [
        -3203.56298828125,
        -4340.0,
        1012.75
      ],
      [
        -3203.56298828125,
        -4340.0,
        1013.75
      ],
      [
        -3203.622802734375,
        -4340.0,
        1013.75
      ],
      [
        -3203.622802734375,
        -4331.0,
        1013.75
      ],
      [
        -3203.56298828125,
        -4331.0,
        1013.75
      ],
      [
        -3203.622802734375,
        -4340.0,
        1013.75
      ],
      [
        -3203.56298828125,
        -4340.0,
        1013.75
      ],
      [
        -3203.56298828125,
        -4340.0,
        1012.75
      ],
      [
        -3204.79736328125,
        -4340.0,
        1012.75
      ],
      [
        -3203.56298828125,
        -4331.0,
        1013.75
      ],
      [
        -3203.622802734375,
        -4331.0,
        1013.75
      ],
      [
        -3204.79736328125,
        -4331.0,
        1012.75
      ],
      [
        -3203.56298828125,
        -4331.0,
        1012.75
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.6782577633857727,
        -0.6209645867347717,
        -0.39289847016334534
      ],
      "plane_d": 1186.9688720703125,
      "bbox_min": [
        -4358.3671875,
        -3498.475830078125,
        984.9754028320312
      ],
      "bbox_max": [
        -4213.92333984375,
        -3335.016845703125,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6795781850814819,
        -0.622826874256134,
        -0.3876340687274933
      ],
      "plane_d": 1180.9044189453125,
      "bbox_min": [
        -4358.3671875,
        -3491.62255859375,
        1010.9993896484375
      ],
      "bbox_max": [
        -4213.92333984375,
        -3341.033203125,
        1027.0509033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28048279881477356,
        -0.257059782743454,
        -0.924796998500824
      ],
      "plane_d": 1272.85205078125,
      "bbox_min": [
        -4351.88623046875,
        -3491.62255859375,
        1026.9976806640625
      ],
      "bbox_max": [
        -4213.92333984375,
        -3341.033203125,
        1027.0509033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.678257405757904,
        -0.6209643483161926,
        0.3928998112678528
      ],
      "plane_d": 392.5263671875,
      "bbox_min": [
        -4358.3671875,
        -3498.475830078125,
        984.9754028320312
      ],
      "bbox_max": [
        -4213.92333984375,
        -3335.016845703125,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6795778274536133,
        -0.6228265166282654,
        0.38763535022735596
      ],
      "plane_d": 397.107421875,
      "bbox_min": [
        -4358.3671875,
        -3491.641357421875,
        994.845703125
      ],
      "bbox_max": [
        -4213.92333984375,
        -3341.033203125,
        1010.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4925941526889801,
        -0.45145776867866516,
        0.7440006732940674
      ],
      "plane_d": -172.863037109375,
      "bbox_min": [
        -4351.88623046875,
        -3491.641357421875,
        994.845703125
      ],
      "bbox_max": [
        -4213.92333984375,
        -3341.033203125,
        995.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4925941526889801,
        -0.45145776867866516,
        0.7440006732940674
      ],
      "plane_d": -172.863037109375,
      "bbox_min": [
        -4351.76171875,
        -3498.475830078125,
        984.9754028320312
      ],
      "bbox_max": [
        -4213.92333984375,
        -3341.033203125,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28048279881477356,
        -0.257059782743454,
        -0.924796998500824
      ],
      "plane_d": 1272.85205078125,
      "bbox_min": [
        -4351.76171875,
        -3498.475830078125,
        1026.9976806640625
      ],
      "bbox_max": [
        -4213.92333984375,
        -3341.033203125,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9049289226531982,
        -0.1581002175807953,
        -0.39510491490364075
      ],
      "plane_d": 3791.90185546875,
      "bbox_min": [
        -4389.13134765625,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4320.759765625,
        -3488.681640625,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9049283862113953,
        -0.15810012817382812,
        0.3951061964035034
      ],
      "plane_d": 2992.9970703125,
      "bbox_min": [
        -4389.13134765625,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4320.759765625,
        -3488.681640625,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9027932286262512,
        -0.15715810656547546,
        -0.40033215284347534
      ],
      "plane_d": 3791.265625,
      "bbox_min": [
        -4389.13134765625,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4320.759765625,
        -3491.567138671875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9027926325798035,
        -0.1571580022573471,
        0.4003334045410156
      ],
      "plane_d": 2981.791015625,
      "bbox_min": [
        -4389.13134765625,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4320.759765625,
        -3491.567138671875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6500900983810425,
        -0.11316759139299393,
        0.7513827681541443
      ],
      "plane_d": 1686.3592529296875,
      "bbox_min": [
        -4382.037109375,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4320.759765625,
        -3491.567138671875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36769089102745056,
        -0.06400758028030396,
        -0.9277426600456238
      ],
      "plane_d": 2329.45166015625,
      "bbox_min": [
        -4382.037109375,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4320.759765625,
        -3491.567138671875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6443429589271545,
        -0.11146288365125656,
        0.756570041179657
      ],
      "plane_d": 1662.260986328125,
      "bbox_min": [
        -4382.037109375,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4320.759765625,
        -3496.355224609375,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3627394139766693,
        -0.06256627291440964,
        -0.9297878742218018
      ],
      "plane_d": 2315.13671875,
      "bbox_min": [
        -4382.037109375,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4320.759765625,
        -3496.355224609375,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -984.975341796875,
      "bbox_min": [
        -4370.26513671875,
        -3664.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4320.759765625,
        -3496.355224609375,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3660587668418884,
        0.06313879787921906,
        -0.928447425365448
      ],
      "plane_d": -406.810302734375,
      "bbox_min": [
        -4365.05126953125,
        -3664.7685546875,
        1026.9976806640625
      ],
      "bbox_max": [
        -4320.759765625,
        -3498.475830078125,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3609141409397125,
        0.061620891094207764,
        -0.9305609464645386
      ],
      "plane_d": -387.73193359375,
      "bbox_min": [
        -4365.05126953125,
        -3664.7685546875,
        1026.9976806640625
      ],
      "bbox_max": [
        -4320.759765625,
        -3505.42529296875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3612746000289917,
        0.04250289127230644,
        -0.9314902424812317
      ],
      "plane_d": -458.4078369140625,
      "bbox_min": [
        -4429.13134765625,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4340.970703125,
        -3664.7685546875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3631196618080139,
        -0.04271996393799782,
        -0.9307626485824585
      ],
      "plane_d": 2390.5361328125,
      "bbox_min": [
        -4429.13134765625,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4340.970703125,
        -3664.7685546875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9089117050170898,
        -0.10693079233169556,
        -0.40304532647132874
      ],
      "plane_d": 4004.934814453125,
      "bbox_min": [
        -4429.13134765625,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4340.970703125,
        -3664.7685546875,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9089111089706421,
        -0.10693071782588959,
        0.403046578168869
      ],
      "plane_d": 3189.97412109375,
      "bbox_min": [
        -4429.13134765625,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4340.970703125,
        -3664.7685546875,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9109771847724915,
        0.10717379301786423,
        -0.3982892334461212
      ],
      "plane_d": -3159.088134765625,
      "bbox_min": [
        -4422.037109375,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4340.970703125,
        -3664.7685546875,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9109766483306885,
        0.10717372596263885,
        0.3982905149459839
      ],
      "plane_d": -3964.427490234375,
      "bbox_min": [
        -4422.037109375,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4340.970703125,
        -3664.7685546875,
        1010.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6422120332717896,
        0.07555435597896576,
        0.7627943754196167
      ],
      "plane_d": -3274.40771484375,
      "bbox_min": [
        -4422.037109375,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4347.96533203125,
        -3664.7685546875,
        995.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6465049982070923,
        -0.07605941593647003,
        0.7591087222099304
      ],
      "plane_d": 1798.95458984375,
      "bbox_min": [
        -4422.037109375,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4359.87353515625,
        -3664.7685546875,
        995.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -984.9754028320312,
      "bbox_min": [
        -4410.26513671875,
        -4004.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4359.87353515625,
        -3664.7685546875,
        984.9754028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36138391494750977,
        0.034675855189561844,
        -0.9317721128463745
      ],
      "plane_d": -489.9434814453125,
      "bbox_min": [
        -4469.13134765625,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4380.970703125,
        -4004.7685546875,
        1034.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3631659150123596,
        -0.03963465988636017,
        -0.9308810830116272
      ],
      "plane_d": 2403.21826171875,
      "bbox_min": [
        -4469.13134765625,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4380.970703125,
        -4004.7685546875,
        1034.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9100728034973145,
        -0.09437557309865952,
        -0.40356016159057617
      ],
      "plane_d": 4060.878662109375,
      "bbox_min": [
        -4469.13134765625,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4380.970703125,
        -4004.7685546875,
        1027.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9102475643157959,
        -0.09232374280691147,
        0.4036407470703125
      ],
      "plane_d": 3253.7900390625,
      "bbox_min": [
        -4469.13134765625,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4380.970703125,
        -4004.7685546875,
        1027.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9123221039772034,
        0.09254872798919678,
        -0.39887726306915283
      ],
      "plane_d": -3222.95556640625,
      "bbox_min": [
        -4462.037109375,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4380.970703125,
        -4004.7685546875,
        1027.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9121464490890503,
        0.09457611292600632,
        0.3988034725189209
      ],
      "plane_d": -4020.521484375,
      "bbox_min": [
        -4462.037109375,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4380.970703125,
        -4004.7685546875,
        1011.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.642572820186615,
        0.06786175072193146,
        0.763213574886322
      ],
      "plane_d": -3307.21533203125,
      "bbox_min": [
        -4462.037109375,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4387.96533203125,
        -4004.7685546875,
        996.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6470412611961365,
        -0.06441505998373032,
        0.7597290873527527
      ],
      "plane_d": 1847.3416748046875,
      "bbox_min": [
        -4462.037109375,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4399.87353515625,
        -4004.7685546875,
        996.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.002563937334343791,
        0.9999966621398926
      ],
      "plane_d": -974.7041625976562,
      "bbox_min": [
        -4450.26513671875,
        -4394.7685546875,
        984.9754028320312
      ],
      "bbox_max": [
        -4399.87353515625,
        -4004.7685546875,
        985.975341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3598810136318207,
        0.09742920100688934,
        -0.9278971552848816
      ],
      "plane_d": -211.4857177734375,
      "bbox_min": [
        -4469.13134765625,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4420.970703125,
        -4394.7685546875,
        1034.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3617250323295593,
        0.0973547101020813,
        -0.9271877408027649
      ],
      "plane_d": 2995.02880859375,
      "bbox_min": [
        -4469.13134765625,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4420.970703125,
        -4394.7685546875,
        1034.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9133259654045105,
        0.042525287717580795,
        -0.40500277280807495
      ],
      "plane_d": 4678.525390625,
      "bbox_min": [
        -4469.13134765625,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4420.970703125,
        -4394.7685546875,
        1027.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9133248925209045,
        -0.04252556338906288,
        0.4050053656101227
      ],
      "plane_d": 3485.013671875,
      "bbox_min": [
        -4469.13134765625,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4420.970703125,
        -4394.7685546875,
        1027.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.91544508934021,
        0.042025476694107056,
        -0.4002426564693451
      ],
      "plane_d": -3457.41845703125,
      "bbox_min": [
        -4462.037109375,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4420.970703125,
        -4394.7685546875,
        1027.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9154439568519592,
        -0.042025744915008545,
        0.40024518966674805
      ],
      "plane_d": -4636.892578125,
      "bbox_min": [
        -4462.037109375,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4420.970703125,
        -4394.7685546875,
        1011.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6419899463653564,
        -0.08006472885608673,
        0.7625212073326111
      ],
      "plane_d": -3954.04736328125,
      "bbox_min": [
        -4462.037109375,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4427.96533203125,
        -4394.7685546875,
        996.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6463261246681213,
        -0.07968314737081528,
        0.758889377117157
      ],
      "plane_d": 1777.887451171875,
      "bbox_min": [
        -4462.037109375,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4439.87353515625,
        -4394.7685546875,
        996.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10442563146352768,
        0.9945327639579773
      ],
      "plane_d": -1439.51123046875,
      "bbox_min": [
        -4450.26513671875,
        -4594.7685546875,
        964.9754028320312
      ],
      "bbox_max": [
        -4439.87353515625,
        -4394.7685546875,
        985.975341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3613501787185669,
        0.03726740926504135,
        -0.931685209274292
      ],
      "plane_d": -490.6060791015625,
      "bbox_min": [
        -4469.13134765625,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4420.970703125,
        -4594.7685546875,
        1013.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3631994128227234,
        0.037238676100969315,
        -0.9309669733047485
      ],
      "plane_d": 2729.19384765625,
      "bbox_min": [
        -4469.13134765625,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4420.970703125,
        -4594.7685546875,
        1013.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140328168869019,
        0.016212647780776024,
        -0.40531620383262634
      ],
      "plane_d": 4561.09423828125,
      "bbox_min": [
        -4469.13134765625,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4420.970703125,
        -4594.7685546875,
        1006.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140316247940063,
        -0.01621275022625923,
        0.4053187668323517
      ],
      "plane_d": 3608.762939453125,
      "bbox_min": [
        -4469.13134765625,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4420.970703125,
        -4594.7685546875,
        1006.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161369204521179,
        0.01602180488407612,
        -0.4005451202392578
      ],
      "plane_d": -3579.658203125,
      "bbox_min": [
        -4462.037109375,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4420.970703125,
        -4594.7685546875,
        1006.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161357879638672,
        -0.016021907329559326,
        0.40054768323898315
      ],
      "plane_d": -4520.76904296875,
      "bbox_min": [
        -4462.037109375,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4420.970703125,
        -4594.7685546875,
        990.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6437538266181946,
        -0.030584843829274178,
        0.7646210789680481
      ],
      "plane_d": -3736.556396484375,
      "bbox_min": [
        -4462.037109375,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4427.96533203125,
        -4594.7685546875,
        975.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6480850577354431,
        -0.030438559129834175,
        0.7609593868255615
      ],
      "plane_d": 2009.985107421875,
      "bbox_min": [
        -4462.037109375,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4439.87353515625,
        -4594.7685546875,
        975.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.039968281984329224,
        0.9992009997367859
      ],
      "plane_d": -1147.849365234375,
      "bbox_min": [
        -4450.26513671875,
        -4844.7685546875,
        954.975341796875
      ],
      "bbox_max": [
        -4439.87353515625,
        -4594.7685546875,
        964.9754028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8959311246871948,
        0.1986609250307083,
        0.39729228615760803
      ],
      "plane_d": 4576.75634765625,
      "bbox_min": [
        -4469.13134765625,
        -5039.365234375,
        934.9754028320312
      ],
      "bbox_max": [
        -4375.40478515625,
        -4844.7685546875,
        1003.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8991361856460571,
        0.19956056773662567,
        0.3895249664783478
      ],
      "plane_d": 4602.91162109375,
      "bbox_min": [
        -4462.037109375,
        -5039.365234375,
        944.7672119140625
      ],
      "bbox_max": [
        -4410.73193359375,
        -4844.7685546875,
        965.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6455652117729187,
        0.093207947909832,
        0.7579959630966187
      ],
      "plane_d": 2600.639892578125,
      "bbox_min": [
        -4462.037109375,
        -5035.818359375,
        944.7672119140625
      ],
      "bbox_max": [
        -4410.73193359375,
        -4844.7685546875,
        965.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6681129336357117,
        0.09891799092292786,
        0.7374553084373474
      ],
      "plane_d": 2748.2626953125,
      "bbox_min": [
        -4411.8330078125,
        -5035.818359375,
        944.7672119140625
      ],
      "bbox_max": [
        -4410.73193359375,
        -5031.62060546875,
        945.2203369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8756047487258911,
        0.2748812437057495,
        -0.3971858322620392
      ],
      "plane_d": 5634.56787109375,
      "bbox_min": [
        -4469.13134765625,
        -5039.365234375,
        934.9754028320312
      ],
      "bbox_max": [
        -4375.40478515625,
        -4844.7685546875,
        1003.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.878730297088623,
        0.2756752073764801,
        -0.3896617293357849
      ],
      "plane_d": 5645.00146484375,
      "bbox_min": [
        -4469.13134765625,
        -5035.818359375,
        976.9976806640625
      ],
      "bbox_max": [
        -4410.9697265625,
        -4844.7685546875,
        997.0745849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31478407979011536,
        0.18166735768318176,
        -0.9316157102584839
      ],
      "plane_d": 3213.533203125,
      "bbox_min": [
        -4462.037109375,
        -5035.818359375,
        976.9976806640625
      ],
      "bbox_max": [
        -4410.9697265625,
        -4844.7685546875,
        997.0745849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35644805431365967,
        0.19536425173282623,
        -0.9136616587638855
      ],
      "plane_d": 3447.8974609375,
      "bbox_min": [
        -4462.037109375,
        -4846.80712890625,
        996.8483276367188
      ],
      "bbox_max": [
        -4461.302734375,
        -4844.7685546875,
        997.0745849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31478407979011536,
        0.18166735768318176,
        -0.9316157102584839
      ],
      "plane_d": 3213.533203125,
      "bbox_min": [
        -4462.037109375,
        -5035.818359375,
        934.9754028320312
      ],
      "bbox_max": [
        -4375.40478515625,
        -4844.7685546875,
        1003.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4048488438129425,
        -0.008032616227865219,
        -0.9143483638763428
      ],
      "plane_d": -920.8276977539062,
      "bbox_min": [
        -4445.05126953125,
        -5027.3251953125,
        983.6243896484375
      ],
      "bbox_max": [
        -4396.25927734375,
        -4844.7685546875,
        1003.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36158135533332825,
        0.010522343218326569,
        -0.9322812557220459
      ],
      "plane_d": -620.6091918945312,
      "bbox_min": [
        -4445.05126953125,
        -4855.658203125,
        1001.9581298828125
      ],
      "bbox_max": [
        -4441.07177734375,
        -4844.7685546875,
        1003.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6455652117729187,
        0.093207947909832,
        0.7579959630966187
      ],
      "plane_d": 2600.639892578125,
      "bbox_min": [
        -4462.037109375,
        -5035.68115234375,
        934.9754028320312
      ],
      "bbox_max": [
        -4375.40478515625,
        -4844.7685546875,
        1003.150146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053711019456386566,
        -0.09303145855665207,
        0.9942134022712708
      ],
      "plane_d": -1161.136962890625,
      "bbox_min": [
        -4450.26513671875,
        -5035.68115234375,
        934.9754028320312
      ],
      "bbox_max": [
        -4400.10400390625,
        -4844.7685546875,
        954.975341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6681129336357117,
        0.09891799092292786,
        0.7374553084373474
      ],
      "plane_d": 2748.2626953125,
      "bbox_min": [
        -4450.26513671875,
        -5035.68115234375,
        934.9754028320312
      ],
      "bbox_max": [
        -4400.77490234375,
        -4844.7685546875,
        954.975341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053711019456386566,
        -0.09303145855665207,
        0.9942134022712708
      ],
      "plane_d": -1161.136962890625,
      "bbox_min": [
        -4450.26513671875,
        -5029.544921875,
        934.9754028320312
      ],
      "bbox_max": [
        -4375.40478515625,
        -4844.7685546875,
        1003.150146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5994331240653992,
        -0.24489063024520874,
        0.762042224407196
      ],
      "plane_d": -4575.5771484375,
      "bbox_min": [
        -4443.82861328125,
        -5027.3251953125,
        934.9754028320312
      ],
      "bbox_max": [
        -4375.40478515625,
        -4844.7685546875,
        1003.150146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6233276128768921,
        -0.25166821479797363,
        0.7403551340103149
      ],
      "plane_d": -4693.791015625,
      "bbox_min": [
        -4443.82861328125,
        -5027.3251953125,
        945.0011596679688
      ],
      "bbox_max": [
        -4375.40478515625,
        -4844.7685546875,
        1003.150146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.898665726184845,
        -0.19499880075454712,
        -0.3929065465927124
      ],
      "plane_d": -4532.2578125,
      "bbox_min": [
        -4443.82861328125,
        -5027.3251953125,
        945.0011596679688
      ],
      "bbox_max": [
        -4375.40478515625,
        -4844.7685546875,
        1003.150146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8761810660362244,
        -0.27929553389549255,
        0.39281129837036133
      ],
      "plane_d": -5611.884765625,
      "bbox_min": [
        -4443.82861328125,
        -5027.3251953125,
        945.0011596679688
      ],
      "bbox_max": [
        -4375.40478515625,
        -4844.7685546875,
        1003.150146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36158135533332825,
        0.010522343218326569,
        -0.9322812557220459
      ],
      "plane_d": -620.6091918945312,
      "bbox_min": [
        -4443.82861328125,
        -5027.3251953125,
        960.9993896484375
      ],
      "bbox_max": [
        -4375.40478515625,
        -4844.7685546875,
        1003.150146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4048488438129425,
        -0.008032616227865219,
        -0.9143483638763428
      ],
      "plane_d": -920.8276977539062,
      "bbox_min": [
        -4441.07177734375,
        -5027.3251953125,
        976.9976806640625
      ],
      "bbox_max": [
        -4381.46240234375,
        -4855.658203125,
        1001.9581298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9021173119544983,
        -0.19597768783569336,
        -0.38441789150238037
      ],
      "plane_d": -4560.5869140625,
      "bbox_min": [
        -4427.96533203125,
        -5018.7822265625,
        960.9993896484375
      ],
      "bbox_max": [
        -4375.40478515625,
        -4844.7685546875,
        980.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.879564642906189,
        -0.2801447808742523,
        0.3845582604408264
      ],
      "plane_d": -5623.017578125,
      "bbox_min": [
        -4427.96533203125,
        -5015.28515625,
        960.9993896484375
      ],
      "bbox_max": [
        -4375.40478515625,
        -4844.7685546875,
        980.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7021172046661377,
        0.5889592170715332,
        0.4001980721950531
      ],
      "plane_d": 5684.7216796875,
      "bbox_min": [
        -4417.11328125,
        -5181.8818359375,
        894.9754028320312
      ],
      "bbox_max": [
        -4250.685546875,
        -5015.28515625,
        983.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7057133913040161,
        0.5948261618614197,
        0.38490328192710876
      ],
      "plane_d": 5744.5830078125,
      "bbox_min": [
        -4410.9697265625,
        -5181.8818359375,
        904.52001953125
      ],
      "bbox_max": [
        -4270.9365234375,
        -5035.818359375,
        945.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5815938115119934,
        0.3744358718395233,
        0.7221817374229431
      ],
      "plane_d": 3768.52099609375,
      "bbox_min": [
        -4410.9697265625,
        -5175.73828125,
        904.52001953125
      ],
      "bbox_max": [
        -4270.9365234375,
        -5035.818359375,
        945.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5898206233978271,
        0.70142662525177,
        -0.40014028549194336
      ],
      "plane_d": 6524.583984375,
      "bbox_min": [
        -4417.11328125,
        -5181.8818359375,
        894.9754028320312
      ],
      "bbox_max": [
        -4250.685546875,
        -5015.28515625,
        983.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5956243276596069,
        0.7049746513366699,
        -0.3850228190422058
      ],
      "plane_d": 6553.5712890625,
      "bbox_min": [
        -4417.11328125,
        -5175.73828125,
        936.9976806640625
      ],
      "bbox_max": [
        -4271.21875,
        -5035.61279296875,
        977.1580810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09683236479759216,
        0.36178645491600037,
        -0.9272184371948242
      ],
      "plane_d": 3154.905517578125,
      "bbox_min": [
        -4410.9697265625,
        -5175.73828125,
        936.9976806640625
      ],
      "bbox_max": [
        -4271.21875,
        -5035.61279296875,
        977.1580810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15714304149150848,
        0.4238094091415405,
        -0.8920155763626099
      ],
      "plane_d": 3698.877685546875,
      "bbox_min": [
        -4410.9697265625,
        -5038.619140625,
        976.2511596679688
      ],
      "bbox_max": [
        -4407.65380859375,
        -5035.61279296875,
        977.1580810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5815938115119934,
        0.3744358718395233,
        0.7221817374229431
      ],
      "plane_d": 3768.52099609375,
      "bbox_min": [
        -4410.9697265625,
        -5175.73828125,
        894.9754028320312
      ],
      "bbox_max": [
        -4250.685546875,
        -5015.28515625,
        983.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09683236479759216,
        0.36178645491600037,
        -0.9272184371948242
      ],
      "plane_d": 3154.905517578125,
      "bbox_min": [
        -4410.61376953125,
        -5175.73828125,
        894.9754028320312
      ],
      "bbox_max": [
        -4250.685546875,
        -5015.28515625,
        983.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4230878949165344,
        -0.1554976850748062,
        -0.892646074295044
      ],
      "plane_d": -1763.713134765625,
      "bbox_min": [
        -4396.25927734375,
        -5161.02783203125,
        943.6243896484375
      ],
      "bbox_max": [
        -4262.72607421875,
        -5026.005859375,
        983.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3694462180137634,
        -0.0783461481332779,
        -0.9259435534477234
      ],
      "plane_d": -1107.2723388671875,
      "bbox_min": [
        -4396.25927734375,
        -5041.34521484375,
        978.1266479492188
      ],
      "bbox_max": [
        -4379.5068359375,
        -5026.005859375,
        983.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1829243153333664,
        -0.10560998320579529,
        0.9774380922317505
      ],
      "plane_d": -640.0828247070312,
      "bbox_min": [
        -4400.77490234375,
        -5165.54345703125,
        894.9754028320312
      ],
      "bbox_max": [
        -4250.685546875,
        -5015.28515625,
        982.6010131835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10848277062177658,
        -0.18790018558502197,
        0.9761788249015808
      ],
      "plane_d": -1380.420166015625,
      "bbox_min": [
        -4400.77490234375,
        -5161.02783203125,
        894.9754028320312
      ],
      "bbox_max": [
        -4250.685546875,
        -5015.28515625,
        982.6010131835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3245604634284973,
        -0.5562942624092102,
        0.7649818658828735
      ],
      "plane_d": -4935.8681640625,
      "bbox_min": [
        -4393.97412109375,
        -5161.02783203125,
        894.9754028320312
      ],
      "bbox_max": [
        -4250.685546875,
        -5015.28515625,
        982.6010131835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36246800422668457,
        -0.5887424349784851,
        0.7224951386451721
      ],
      "plane_d": -5225.66845703125,
      "bbox_min": [
        -4393.97412109375,
        -5161.02783203125,
        905.0011596679688
      ],
      "bbox_max": [
        -4250.685546875,
        -5015.28515625,
        982.6010131835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7088893055915833,
        -0.5836623311042786,
        -0.3959977626800537
      ],
      "plane_d": -5648.35693359375,
      "bbox_min": [
        -4393.97412109375,
        -5161.02783203125,
        905.0011596679688
      ],
      "bbox_max": [
        -4250.685546875,
        -5015.28515625,
        982.6010131835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5846330523490906,
        -0.7081219553947449,
        0.39593878388404846
      ],
      "plane_d": -6489.6201171875,
      "bbox_min": [
        -4393.97412109375,
        -5161.02783203125,
        905.0011596679688
      ],
      "bbox_max": [
        -4250.685546875,
        -5015.28515625,
        982.6010131835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7126259207725525,
        -0.5901885628700256,
        -0.3792647123336792
      ],
      "plane_d": -5713.517578125,
      "bbox_min": [
        -4393.97412109375,
        -5161.02783203125,
        920.9993896484375
      ],
      "bbox_max": [
        -4250.685546875,
        -5015.28515625,
        982.6010131835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5910871028900146,
        -0.7118058800697327,
        0.3794053792953491
      ],
      "plane_d": -6520.76318359375,
      "bbox_min": [
        -4393.97412109375,
        -5161.02783203125,
        920.9993896484375
      ],
      "bbox_max": [
        -4250.685546875,
        -5015.28515625,
        982.6010131835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3694462180137634,
        -0.0783461481332779,
        -0.9259435534477234
      ],
      "plane_d": -1107.2723388671875,
      "bbox_min": [
        -4393.97412109375,
        -5161.02783203125,
        936.9976806640625
      ],
      "bbox_max": [
        -4254.18310546875,
        -5018.7822265625,
        982.6010131835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4230878949165344,
        -0.1554976850748062,
        -0.892646074295044
      ],
      "plane_d": -1763.713134765625,
      "bbox_min": [
        -4379.5068359375,
        -5161.02783203125,
        936.9976806640625
      ],
      "bbox_max": [
        -4254.18310546875,
        -5041.34521484375,
        978.1266479492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27592095732688904,
        0.8752333521842957,
        0.397283673286438
      ],
      "plane_d": 5348.95556640625,
      "bbox_min": [
        -4274.76611328125,
        -5234.13134765625,
        874.9754028320312
      ],
      "bbox_max": [
        -4080.2314453125,
        -5140.17333984375,
        943.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27674195170402527,
        0.8784493803977966,
        0.38953879475593567
      ],
      "plane_d": 5376.11669921875,
      "bbox_min": [
        -4271.21875,
        -5234.13134765625,
        884.7680053710938
      ],
      "bbox_max": [
        -4080.2314453125,
        -5175.73828125,
        905.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2460722029209137,
        0.6284464597702026,
        0.7379048466682434
      ],
      "plane_d": 3635.897705078125,
      "bbox_min": [
        -4271.21875,
        -5227.037109375,
        884.7680053710938
      ],
      "bbox_max": [
        -4080.2314453125,
        -5175.73828125,
        905.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19974581897258759,
        0.8957306146621704,
        -0.3972006142139435
      ],
      "plane_d": 5861.25830078125,
      "bbox_min": [
        -4274.76611328125,
        -5234.13134765625,
        874.9754028320312
      ],
      "bbox_max": [
        -4080.2314453125,
        -5140.17333984375,
        943.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20062372088432312,
        0.8988440632820129,
        -0.3896529972553253
      ],
      "plane_d": 5874.19384765625,
      "bbox_min": [
        -4274.76611328125,
        -5227.037109375,
        916.9976806640625
      ],
      "bbox_max": [
        -4080.2314453125,
        -5175.56640625,
        937.0751342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.478992872871459e-05,
        0.3634515106678009,
        -0.9316130876541138
      ],
      "plane_d": 2754.325927734375,
      "bbox_min": [
        -4271.21875,
        -5227.037109375,
        916.9976806640625
      ],
      "bbox_max": [
        -4080.2314453125,
        -5175.56640625,
        937.0751342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00903230533003807,
        0.40636950731277466,
        -0.9136641025543213
      ],
      "plane_d": 2997.9423828125,
      "bbox_min": [
        -4271.21875,
        -5176.1240234375,
        936.8473510742188
      ],
      "bbox_max": [
        -4269.07177734375,
        -5175.56640625,
        937.0751342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2460722029209137,
        0.6284464597702026,
        0.7379048466682434
      ],
      "plane_d": 3635.897705078125,
      "bbox_min": [
        -4271.21875,
        -5227.037109375,
        874.9754028320312
      ],
      "bbox_max": [
        -4080.2314453125,
        -5140.17333984375,
        943.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.478992872871459e-05,
        0.3634515106678009,
        -0.9316130876541138
      ],
      "plane_d": 2754.325927734375,
      "bbox_min": [
        -4271.11962890625,
        -5227.037109375,
        874.9754028320312
      ],
      "bbox_max": [
        -4080.2314453125,
        -5140.17333984375,
        943.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19546851515769958,
        -0.3546260893344879,
        -0.9143480658531189
      ],
      "plane_d": -1800.6627197265625,
      "bbox_min": [
        -4262.72607421875,
        -5210.05126953125,
        923.6243896484375
      ],
      "bbox_max": [
        -4080.2314453125,
        -5159.96923828125,
        943.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18990369141101837,
        -0.30787691473960876,
        -0.9322813153266907
      ],
      "plane_d": -1518.745361328125,
      "bbox_min": [
        -4262.72607421875,
        -5163.02587890625,
        941.9586181640625
      ],
      "bbox_max": [
        -4251.30908203125,
        -5159.96923828125,
        943.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10742354393005371,
        -0.0,
        0.994213342666626
      ],
      "plane_d": -431.59930419921875,
      "bbox_min": [
        -4265.3330078125,
        -5215.26513671875,
        874.9754028320312
      ],
      "bbox_max": [
        -4080.2314453125,
        -5140.17333984375,
        943.1503295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09565360844135284,
        -0.05522489547729492,
        0.9938815832138062
      ],
      "plane_d": -766.7716064453125,
      "bbox_min": [
        -4265.3330078125,
        -5210.05126953125,
        874.9754028320312
      ],
      "bbox_max": [
        -4080.2314453125,
        -5140.17333984375,
        943.1503295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08763643354177475,
        -0.6415749192237854,
        0.7620376944541931
      ],
      "plane_d": -4363.65771484375,
      "bbox_min": [
        -4262.11474609375,
        -5210.05126953125,
        874.9754028320312
      ],
      "bbox_max": [
        -4080.2314453125,
        -5140.17333984375,
        943.1503295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09371025115251541,
        -0.6656416058540344,
        0.7403645515441895
      ],
      "plane_d": -4494.23681640625,
      "bbox_min": [
        -4262.11474609375,
        -5210.05126953125,
        885.0011596679688
      ],
      "bbox_max": [
        -4080.2314453125,
        -5140.17333984375,
        943.1503295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2804601490497589,
        -0.8757626414299011,
        -0.3929145038127899
      ],
      "plane_d": -5331.845703125,
      "bbox_min": [
        -4262.11474609375,
        -5210.05126953125,
        885.0011596679688
      ],
      "bbox_max": [
        -4080.2314453125,
        -5140.17333984375,
        943.1503295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19621515274047852,
        -0.898442804813385,
        0.39281055331230164
      ],
      "plane_d": -5813.82275390625,
      "bbox_min": [
        -4262.11474609375,
        -5210.05126953125,
        885.0011596679688
      ],
      "bbox_max": [
        -4080.2314453125,
        -5140.17333984375,
        943.1503295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18990369141101837,
        -0.30787691473960876,
        -0.9322813153266907
      ],
      "plane_d": -1518.745361328125,
      "bbox_min": [
        -4262.11474609375,
        -5210.05126953125,
        900.9993896484375
      ],
      "bbox_max": [
        -4080.2314453125,
        -5140.17333984375,
        943.1503295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19546851515769958,
        -0.3546260893344879,
        -0.9143480658531189
      ],
      "plane_d": -1800.6627197265625,
      "bbox_min": [
        -4251.30908203125,
        -5210.05126953125,
        916.9976806640625
      ],
      "bbox_max": [
        -4080.2314453125,
        -5163.02587890625,
        941.9586181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2813393175601959,
        -0.8792455792427063,
        -0.3844158351421356
      ],
      "plane_d": -5361.31298828125,
      "bbox_min": [
        -4254.18310546875,
        -5192.96533203125,
        900.9993896484375
      ],
      "bbox_max": [
        -4080.2314453125,
        -5140.17333984375,
        920.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.197170689702034,
        -0.9017950892448425,
        0.3845641314983368
      ],
      "plane_d": -5827.6767578125,
      "bbox_min": [
        -4254.18310546875,
        -5185.970703125,
        900.9993896484375
      ],
      "bbox_max": [
        -4080.2314453125,
        -5140.17333984375,
        920.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03726740926504135,
        -0.3613501787185669,
        -0.931685209274292
      ],
      "plane_d": -1174.185546875,
      "bbox_min": [
        -4080.2314453125,
        -5234.13134765625,
        864.9754028320312
      ],
      "bbox_max": [
        -3830.2314453125,
        -5185.970703125,
        923.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.037238676100969315,
        0.3631994128227234,
        -0.9309669733047485
      ],
      "plane_d": 2600.208984375,
      "bbox_min": [
        -4080.2314453125,
        -5234.13134765625,
        864.9754028320312
      ],
      "bbox_max": [
        -3830.2314453125,
        -5185.970703125,
        923.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016212647780776024,
        0.9140328168869019,
        -0.40531620383262634
      ],
      "plane_d": 5083.2060546875,
      "bbox_min": [
        -4080.2314453125,
        -5234.13134765625,
        864.9754028320312
      ],
      "bbox_max": [
        -3830.2314453125,
        -5185.970703125,
        916.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016212698072195053,
        0.9140322208404541,
        0.405317485332489
      ],
      "plane_d": 4485.125,
      "bbox_min": [
        -4080.2314453125,
        -5234.13134765625,
        864.9754028320312
      ],
      "bbox_max": [
        -3830.2314453125,
        -5185.970703125,
        916.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01602180488407612,
        -0.9161369204521179,
        -0.4005451202392578
      ],
      "plane_d": -4455.54052734375,
      "bbox_min": [
        -4080.2314453125,
        -5227.037109375,
        864.9754028320312
      ],
      "bbox_max": [
        -3830.2314453125,
        -5185.970703125,
        916.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016021855175495148,
        -0.9161363244056702,
        0.4005464017391205
      ],
      "plane_d": -5046.5751953125,
      "bbox_min": [
        -4080.2314453125,
        -5227.037109375,
        864.9754028320312
      ],
      "bbox_max": [
        -3830.2314453125,
        -5185.970703125,
        900.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.030584920197725296,
        -0.6437515616416931,
        0.7646229863166809
      ],
      "plane_d": -3894.87841796875,
      "bbox_min": [
        -4080.2314453125,
        -5227.037109375,
        864.9754028320312
      ],
      "bbox_max": [
        -3830.2314453125,
        -5192.96533203125,
        885.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03043845109641552,
        0.6480827331542969,
        0.7609612941741943
      ],
      "plane_d": 2838.296875,
      "bbox_min": [
        -4080.2314453125,
        -5227.037109375,
        864.9754028320312
      ],
      "bbox_max": [
        -3830.2314453125,
        -5204.87353515625,
        885.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.039968039840459824,
        0.0,
        0.9992009997367859
      ],
      "plane_d": -711.1974487304688,
      "bbox_min": [
        -4080.2314453125,
        -5215.26513671875,
        864.9754028320312
      ],
      "bbox_max": [
        -3830.2314453125,
        -5204.87353515625,
        874.9754028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01525735855102539,
        -0.36155930161476135,
        -0.9322242736816406
      ],
      "plane_d": -973.6004638671875,
      "bbox_min": [
        -3830.2314453125,
        -5234.13134765625,
        864.9754028320312
      ],
      "bbox_max": [
        -3585.83154296875,
        -5185.970703125,
        917.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.015245585702359676,
        0.36340928077697754,
        -0.9315049648284912
      ],
      "plane_d": 2802.82080078125,
      "bbox_min": [
        -3830.2314453125,
        -5234.13134765625,
        864.9754028320312
      ],
      "bbox_max": [
        -3585.83154296875,
        -5185.970703125,
        917.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0066343811340630054,
        0.914132833480835,
        -0.40536054968833923
      ],
      "plane_d": 5171.2783203125,
      "bbox_min": [
        -3830.2314453125,
        -5234.13134765625,
        864.9754028320312
      ],
      "bbox_max": [
        -3585.83154296875,
        -5185.970703125,
        910.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.006634402088820934,
        0.9141322374343872,
        0.4053618311882019
      ],
      "plane_d": 4398.099609375,
      "bbox_min": [
        -3830.2314453125,
        -5234.13134765625,
        864.9754028320312
      ],
      "bbox_max": [
        -3585.83154296875,
        -5185.970703125,
        910.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.006556292064487934,
        -0.9162343740463257,
        0.4005892872810364
      ],
      "plane_d": -5133.6015625,
      "bbox_min": [
        -3830.2314453125,
        -5227.037109375,
        864.9754028320312
      ],
      "bbox_max": [
        -3585.83154296875,
        -5185.970703125,
        910.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0125191705301404,
        -0.6440024375915527,
        0.7649210095405579
      ],
      "plane_d": -4061.54052734375,
      "bbox_min": [
        -3830.2314453125,
        -5227.037109375,
        864.9754028320312
      ],
      "bbox_max": [
        -3585.83154296875,
        -5185.970703125,
        910.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.006556270178407431,
        -0.9162348508834839,
        -0.4005879759788513
      ],
      "plane_d": -4369.53125,
      "bbox_min": [
        -3830.2314453125,
        -5227.037109375,
        864.9754028320312
      ],
      "bbox_max": [
        -3585.83154296875,
        -5185.970703125,
        910.9976806640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.012459170073270798,
        0.648332953453064,
        0.7612550258636475
      ],
      "plane_d": 2675.039794921875,
      "bbox_min": [
        -3830.2314453125,
        -5227.037109375,
        864.9754028320312
      ],
      "bbox_max": [
        -3585.83154296875,
        -5204.87353515625,
        879.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016364427283406258,
        0.0,
        0.9998661279678345
      ],
      "plane_d": -927.5391845703125,
      "bbox_min": [
        -3830.2314453125,
        -5215.26513671875,
        864.9754028320312
      ],
      "bbox_max": [
        -3585.83154296875,
        -5204.87353515625,
        868.9754028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19866149127483368,
        0.8959322571754456,
        -0.3972897231578827
      ],
      "plane_d": 4332.634765625,
      "bbox_min": [
        -3585.83154296875,
        -5234.13134765625,
        868.9754028320312
      ],
      "bbox_max": [
        -3391.23486328125,
        -5140.40478515625,
        937.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19956067204475403,
        0.8991356492042542,
        -0.38952624797821045
      ],
      "plane_d": 4339.08203125,
      "bbox_min": [
        -3585.83154296875,
        -5227.037109375,
        910.9976806640625
      ],
      "bbox_max": [
        -3391.23486328125,
        -5175.79296875,
        931.0772705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.012457707896828651,
        0.40470609068870544,
        -0.9143619537353516
      ],
      "plane_d": 2903.724365234375,
      "bbox_min": [
        -3585.83154296875,
        -5227.037109375,
        910.9976806640625
      ],
      "bbox_max": [
        -3394.781982421875,
        -5175.79296875,
        931.0772705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27488115429878235,
        0.8756025433540344,
        0.39719074964523315
      ],
      "plane_d": 3241.85595703125,
      "bbox_min": [
        -3585.83154296875,
        -5234.13134765625,
        868.9754028320312
      ],
      "bbox_max": [
        -3391.23486328125,
        -5140.40478515625,
        937.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2756754755973816,
        0.8787296414375305,
        0.3896629214286804
      ],
      "plane_d": 3262.112060546875,
      "bbox_min": [
        -3585.83154296875,
        -5234.13134765625,
        878.775146484375
      ],
      "bbox_max": [
        -3394.781982421875,
        -5175.9697265625,
        899.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24133796989917755,
        0.6060360670089722,
        0.7579420804977417
      ],
      "plane_d": 1636.1436767578125,
      "bbox_min": [
        -3585.83154296875,
        -5227.037109375,
        878.775146484375
      ],
      "bbox_max": [
        -3394.781982421875,
        -5175.9697265625,
        899.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24757538735866547,
        0.6281982064247131,
        0.737613320350647
      ],
      "plane_d": 1747.489013671875,
      "bbox_min": [
        -3585.83154296875,
        -5227.037109375,
        878.775146484375
      ],
      "bbox_max": [
        -3581.894287109375,
        -5225.734375,
        879.2132568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.012457707896828651,
        0.40470609068870544,
        -0.9143619537353516
      ],
      "plane_d": 2903.724365234375,
      "bbox_min": [
        -3585.83154296875,
        -5227.037109375,
        868.9754028320312
      ],
      "bbox_max": [
        -3394.781982421875,
        -5140.40478515625,
        937.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24133796989917755,
        0.6060360670089722,
        0.7579420804977417
      ],
      "plane_d": 1636.1436767578125,
      "bbox_min": [
        -3585.83154296875,
        -5226.77197265625,
        868.9754028320312
      ],
      "bbox_max": [
        -3394.781982421875,
        -5140.40478515625,
        937.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09303173422813416,
        -0.0537111759185791,
        0.9942134022712708
      ],
      "plane_d": -1477.6611328125,
      "bbox_min": [
        -3585.83154296875,
        -5215.26513671875,
        868.9754028320312
      ],
      "bbox_max": [
        -3400.66796875,
        -5165.77490234375,
        888.9754028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11045105010271072,
        0.0,
        0.9938815236091614
      ],
      "plane_d": -1259.717529296875,
      "bbox_min": [
        -3585.83154296875,
        -5215.26513671875,
        868.9754028320312
      ],
      "bbox_max": [
        -3574.171142578125,
        -5211.4755859375,
        870.271240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18516314029693604,
        -0.310631662607193,
        -0.9323210716247559
      ],
      "plane_d": -98.9224853515625,
      "bbox_min": [
        -3585.83154296875,
        -5214.49853515625,
        868.9754028320312
      ],
      "bbox_max": [
        -3400.66796875,
        -5140.40478515625,
        937.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0954119935631752,
        -0.665004312992096,
        0.7407196760177612
      ],
      "plane_d": -3762.79931640625,
      "bbox_min": [
        -3585.83154296875,
        -5214.49853515625,
        868.9754028320312
      ],
      "bbox_max": [
        -3400.66796875,
        -5140.40478515625,
        930.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08389616012573242,
        -0.6417823433876038,
        0.7622839212417603
      ],
      "plane_d": -3701.96435546875,
      "bbox_min": [
        -3585.83154296875,
        -5204.87353515625,
        868.9754028320312
      ],
      "bbox_max": [
        -3411.81787109375,
        -5146.46240234375,
        899.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19499851763248444,
        -0.898665189743042,
        0.3929078280925751
      ],
      "plane_d": -4312.8720703125,
      "bbox_min": [
        -3585.83154296875,
        -5192.96533203125,
        879.0011596679688
      ],
      "bbox_max": [
        -3411.81787109375,
        -5146.46240234375,
        899.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19968532025814056,
        -0.3543187379837036,
        -0.9135557413101196
      ],
      "plane_d": -291.67987060546875,
      "bbox_min": [
        -3585.83154296875,
        -5214.49853515625,
        868.9754028320312
      ],
      "bbox_max": [
        -3400.66796875,
        -5140.40478515625,
        930.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11045105010271072,
        0.0,
        0.9938815236091614
      ],
      "plane_d": -1259.717529296875,
      "bbox_min": [
        -3585.83154296875,
        -5214.49853515625,
        868.9754028320312
      ],
      "bbox_max": [
        -3400.66796875,
        -5140.40478515625,
        930.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2792953848838806,
        -0.8761800527572632,
        -0.39281365275382996
      ],
      "plane_d": -3190.61376953125,
      "bbox_min": [
        -3585.83154296875,
        -5192.96533203125,
        880.0966186523438
      ],
      "bbox_max": [
        -3411.81787109375,
        -5140.40478515625,
        930.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19499851763248444,
        -0.898665189743042,
        0.3929078280925751
      ],
      "plane_d": -4312.8720703125,
      "bbox_min": [
        -3585.83154296875,
        -5192.96533203125,
        880.0966186523438
      ],
      "bbox_max": [
        -3411.81787109375,
        -5140.40478515625,
        914.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28014516830444336,
        -0.8795656561851501,
        -0.38455578684806824
      ],
      "plane_d": -3212.67138671875,
      "bbox_min": [
        -3585.83154296875,
        -5192.96533203125,
        894.9993896484375
      ],
      "bbox_max": [
        -3415.315185546875,
        -5140.40478515625,
        914.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6046654582023621,
        0.6894370913505554,
        -0.3988185524940491
      ],
      "plane_d": 1887.097412109375,
      "bbox_min": [
        -3415.315185546875,
        -5182.11328125,
        888.9754028320312
      ],
      "bbox_max": [
        -3248.71826171875,
        -5015.685546875,
        967.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6086366772651672,
        0.6925103068351746,
        -0.3872867524623871
      ],
      "plane_d": 1878.786865234375,
      "bbox_min": [
        -3394.781982421875,
        -5175.9697265625,
        930.9976806640625
      ],
      "bbox_max": [
        -3248.71826171875,
        -5036.06494140625,
        961.1178588867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18728996813297272,
        0.38180503249168396,
        -0.9050676226615906
      ],
      "plane_d": 2183.0185546875,
      "bbox_min": [
        -3394.781982421875,
        -5175.9697265625,
        930.9976806640625
      ],
      "bbox_max": [
        -3254.862060546875,
        -5036.06494140625,
        961.1178588867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6887303590774536,
        0.6055113673210144,
        0.3987559676170349
      ],
      "plane_d": 437.320556640625,
      "bbox_min": [
        -3415.315185546875,
        -5182.11328125,
        888.9754028320312
      ],
      "bbox_max": [
        -3248.71826171875,
        -5015.685546875,
        967.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6917515993118286,
        0.6094250082969666,
        0.3874029517173767
      ],
      "plane_d": 457.743896484375,
      "bbox_min": [
        -3394.986328125,
        -5182.11328125,
        898.6530151367188
      ],
      "bbox_max": [
        -3254.862060546875,
        -5036.21875,
        929.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5334417819976807,
        0.37090086936950684,
        0.7601792216300964
      ],
      "plane_d": -574.548828125,
      "bbox_min": [
        -3394.986328125,
        -5175.9697265625,
        898.6530151367188
      ],
      "bbox_max": [
        -3254.862060546875,
        -5036.21875,
        929.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.557100236415863,
        0.3961305022239685,
        0.7298766374588013
      ],
      "plane_d": -497.0343017578125,
      "bbox_min": [
        -3394.986328125,
        -5175.9697265625,
        898.6530151367188
      ],
      "bbox_max": [
        -3390.65771484375,
        -5171.33984375,
        899.6361694335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18728996813297272,
        0.38180503249168396,
        -0.9050676226615906
      ],
      "plane_d": 2183.0185546875,
      "bbox_min": [
        -3415.315185546875,
        -5175.9697265625,
        888.9754028320312
      ],
      "bbox_max": [
        -3254.862060546875,
        -5015.685546875,
        967.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07999344170093536,
        -0.13855081796646118,
        0.9871193766593933
      ],
      "plane_d": -1865.2783203125,
      "bbox_min": [
        -3415.315185546875,
        -5175.61572265625,
        888.9754028320312
      ],
      "bbox_max": [
        -3254.862060546875,
        -5015.685546875,
        967.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1423991471529007,
        -0.08221308141946793,
        0.9863891005516052
      ],
      "plane_d": -1785.8221435546875,
      "bbox_min": [
        -3406.4169921875,
        -5165.77490234375,
        888.9754028320312
      ],
      "bbox_max": [
        -3274.05615234375,
        -5025.13720703125,
        918.9754028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39022934436798096,
        -0.557689368724823,
        0.7326005101203918
      ],
      "plane_d": -2198.07470703125,
      "bbox_min": [
        -3406.4169921875,
        -5156.775390625,
        888.9754028320312
      ],
      "bbox_max": [
        -3274.05615234375,
        -5025.13720703125,
        918.9754028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35657480359077454,
        -0.5372130274772644,
        0.7643666863441467
      ],
      "plane_d": -2235.34521484375,
      "bbox_min": [
        -3406.4169921875,
        -5156.775390625,
        888.9754028320312
      ],
      "bbox_max": [
        -3396.450439453125,
        -5146.11474609375,
        892.0765991210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.557100236415863,
        0.3961305022239685,
        0.7298766374588013
      ],
      "plane_d": -497.0343017578125,
      "bbox_min": [
        -3415.315185546875,
        -5175.61572265625,
        888.9754028320312
      ],
      "bbox_max": [
        -3254.862060546875,
        -5015.685546875,
        967.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5334417819976807,
        0.37090086936950684,
        0.7601792216300964
      ],
      "plane_d": -574.548828125,
      "bbox_min": [
        -3390.65771484375,
        -5171.33984375,
        899.6361694335938
      ],
      "bbox_max": [
        -3254.862060546875,
        -5030.3330078125,
        929.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.601148247718811,
        -0.6949461102485657,
        0.3945513069629669
      ],
      "plane_d": -1880.207763671875,
      "bbox_min": [
        -3415.315185546875,
        -5155.81689453125,
        889.9071044921875
      ],
      "bbox_max": [
        -3274.05615234375,
        -5015.685546875,
        960.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6941603422164917,
        -0.6021079421043396,
        -0.3944711983203888
      ],
      "plane_d": -363.12548828125,
      "bbox_min": [
        -3415.315185546875,
        -5155.81689453125,
        889.9071044921875
      ],
      "bbox_max": [
        -3274.05615234375,
        -5015.685546875,
        960.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6055158376693726,
        -0.6982048153877258,
        0.38191697001457214
      ],
      "plane_d": -1870.48193359375,
      "bbox_min": [
        -3415.315185546875,
        -5155.81689453125,
        889.9071044921875
      ],
      "bbox_max": [
        -3274.05615234375,
        -5015.685546875,
        944.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6973569989204407,
        -0.6064045429229736,
        -0.38205599784851074
      ],
      "plane_d": -385.8896484375,
      "bbox_min": [
        -3415.315185546875,
        -5155.81689453125,
        889.9071044921875
      ],
      "bbox_max": [
        -3274.05615234375,
        -5015.685546875,
        944.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35657480359077454,
        -0.5372130274772644,
        0.7643666863441467
      ],
      "plane_d": -2235.34521484375,
      "bbox_min": [
        -3411.81787109375,
        -5155.81689453125,
        889.9071044921875
      ],
      "bbox_max": [
        -3274.05615234375,
        -5019.18310546875,
        929.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39022934436798096,
        -0.557689368724823,
        0.7326005101203918
      ],
      "plane_d": -2198.07470703125,
      "bbox_min": [
        -3396.450439453125,
        -5146.11474609375,
        892.0765991210938
      ],
      "bbox_max": [
        -3274.05615234375,
        -5019.18310546875,
        929.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8655104041099548,
        0.3022712767124176,
        -0.3994044065475464
      ],
      "plane_d": -910.98583984375,
      "bbox_min": [
        -3290.426513671875,
        -5039.76611328125,
        918.9754028320312
      ],
      "bbox_max": [
        -3196.46875,
        -4845.2314453125,
        1001.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8712396621704102,
        0.302791565656662,
        -0.38634011149406433
      ],
      "plane_d": -939.568359375,
      "bbox_min": [
        -3254.862060546875,
        -5036.21875,
        960.9976806640625
      ],
      "bbox_max": [
        -3196.46875,
        -4845.2314453125,
        995.1348876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3514575958251953,
        0.2547762393951416,
        -0.9008699655532837
      ],
      "plane_d": 1004.896728515625,
      "bbox_min": [
        -3254.862060546875,
        -5036.21875,
        960.9976806640625
      ],
      "bbox_max": [
        -3203.56298828125,
        -4845.2314453125,
        995.1348876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9005166888237,
        0.17207489907741547,
        0.3993241488933563
      ],
      "plane_d": -2435.668701171875,
      "bbox_min": [
        -3290.426513671875,
        -5039.76611328125,
        918.9754028320312
      ],
      "bbox_max": [
        -3196.46875,
        -4845.2314453125,
        1001.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9056487083435059,
        0.17445483803749084,
        0.38647887110710144
      ],
      "plane_d": -2428.208251953125,
      "bbox_min": [
        -3255.26611328125,
        -5039.76611328125,
        928.603759765625
      ],
      "bbox_max": [
        -3203.56298828125,
        -4845.2314453125,
        963.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6479001641273499,
        0.03859565779566765,
        0.7607468366622925
      ],
      "plane_d": -2621.18408203125,
      "bbox_min": [
        -3255.26611328125,
        -5036.21875,
        928.603759765625
      ],
      "bbox_max": [
        -3203.56298828125,
        -4845.2314453125,
        963.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6852614283561707,
        0.05062249302864075,
        0.7265357375144958
      ],
      "plane_d": -2650.43798828125,
      "bbox_min": [
        -3255.26611328125,
        -5036.21875,
        928.603759765625
      ],
      "bbox_max": [
        -3253.44482421875,
        -5029.37060546875,
        929.8607788085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3514575958251953,
        0.2547762393951416,
        -0.9008699655532837
      ],
      "plane_d": 1004.896728515625,
      "bbox_min": [
        -3290.426513671875,
        -5036.21875,
        918.9754028320312
      ],
      "bbox_max": [
        -3203.56298828125,
        -4845.2314453125,
        1001.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.18066051602363586,
        0.9835454225540161
      ],
      "plane_d": -1812.63671875,
      "bbox_min": [
        -3290.426513671875,
        -5035.9853515625,
        918.9754028320312
      ],
      "bbox_max": [
        -3203.56298828125,
        -4845.2314453125,
        1001.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09282054007053375,
        -0.16076768934726715,
        0.9826180338859558
      ],
      "plane_d": -2014.7811279296875,
      "bbox_min": [
        -3275.158203125,
        -5030.3330078125,
        918.9754028320312
      ],
      "bbox_max": [
        -3225.7265625,
        -4845.2314453125,
        952.9754028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6138396263122559,
        -0.30269092321395874,
        0.7290947437286377
      ],
      "plane_d": -181.3380126953125,
      "bbox_min": [
        -3275.158203125,
        -5025.13720703125,
        918.9754028320312
      ],
      "bbox_max": [
        -3225.7265625,
        -4845.2314453125,
        952.9754028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5689459443092346,
        -0.30233585834503174,
        0.7647833824157715
      ],
      "plane_d": -359.3353271484375,
      "bbox_min": [
        -3275.158203125,
        -5025.13720703125,
        918.9754028320312
      ],
      "bbox_max": [
        -3270.890380859375,
        -5009.4990234375,
        922.80224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6852614283561707,
        0.05062249302864075,
        0.7265357375144958
      ],
      "plane_d": -2650.43798828125,
      "bbox_min": [
        -3290.426513671875,
        -5035.9853515625,
        918.9754028320312
      ],
      "bbox_max": [
        -3203.56298828125,
        -4845.2314453125,
        1001.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6479001641273499,
        0.03859565779566765,
        0.7607468366622925
      ],
      "plane_d": -2621.18408203125,
      "bbox_min": [
        -3253.44482421875,
        -5029.37060546875,
        929.8607788085938
      ],
      "bbox_max": [
        -3203.56298828125,
        -4845.2314453125,
        963.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648696541786194,
        -0.3095940351486206,
        0.3951607346534729
      ],
      "plane_d": 919.5369873046875,
      "bbox_min": [
        -3290.426513671875,
        -5024.5009765625,
        920.0466918945312
      ],
      "bbox_max": [
        -3225.7265625,
        -4845.2314453125,
        994.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9036118984222412,
        -0.1655469536781311,
        -0.39506909251213074
      ],
      "plane_d": 2516.544921875,
      "bbox_min": [
        -3290.426513671875,
        -5024.5009765625,
        920.0466918945312
      ],
      "bbox_max": [
        -3225.7265625,
        -4845.2314453125,
        994.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8711111545562744,
        -0.3100169003009796,
        0.380860835313797
      ],
      "plane_d": 951.466552734375,
      "bbox_min": [
        -3290.426513671875,
        -5024.5009765625,
        920.0466918945312
      ],
      "bbox_max": [
        -3225.7265625,
        -4845.2314453125,
        978.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9091275930404663,
        -0.16826103627681732,
        -0.3810187876224518
      ],
      "plane_d": 2507.53564453125,
      "bbox_min": [
        -3290.426513671875,
        -5024.5009765625,
        920.0466918945312
      ],
      "bbox_max": [
        -3225.7265625,
        -4845.2314453125,
        978.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5689459443092346,
        -0.30233585834503174,
        0.7647833824157715
      ],
      "plane_d": -359.3353271484375,
      "bbox_min": [
        -3284.368896484375,
        -5024.5009765625,
        920.0466918945312
      ],
      "bbox_max": [
        -3225.7265625,
        -4845.2314453125,
        963.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6138396263122559,
        -0.30269092321395874,
        0.7290947437286377
      ],
      "plane_d": -181.3380126953125,
      "bbox_min": [
        -3270.890380859375,
        -5009.4990234375,
        922.80224609375
      ],
      "bbox_max": [
        -3225.7265625,
        -4845.2314453125,
        963.0011596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4400.2314453125,
      "bbox_min": [
        -3244.62939453125,
        -4845.2314453125,
        952.9754028320312
      ],
      "bbox_max": [
        -3094.0,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.359142929315567,
        0.11641040444374084,
        -0.9259940981864929
      ],
      "plane_d": 2648.1708984375,
      "bbox_min": [
        -3244.62939453125,
        -4845.2314453125,
        952.9754028320312
      ],
      "bbox_max": [
        -3196.46875,
        -4600.2314453125,
        1032.42431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3609842360019684,
        0.11632175743579865,
        -0.9252889156341553
      ],
      "plane_d": 327.830322265625,
      "bbox_min": [
        -3244.62939453125,
        -4845.2314453125,
        952.9754028320312
      ],
      "bbox_max": [
        -3196.46875,
        -4600.2314453125,
        1032.42431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9129676222801208,
        -0.05089482665061951,
        0.40484538674354553
      ],
      "plane_d": -3561.213134765625,
      "bbox_min": [
        -3244.62939453125,
        -4845.2314453125,
        952.9754028320312
      ],
      "bbox_max": [
        -3196.46875,
        -4600.2314453125,
        1025.797607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9129682183265686,
        0.05089466646313667,
        -0.40484410524368286
      ],
      "plane_d": -2275.3359375,
      "bbox_min": [
        -3244.62939453125,
        -4845.2314453125,
        952.9754028320312
      ],
      "bbox_max": [
        -3196.46875,
        -4600.2314453125,
        1025.797607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9150943160057068,
        -0.05029711127281189,
        0.4000908434391022
      ],
      "plane_d": 2333.752197265625,
      "bbox_min": [
        -3244.62939453125,
        -4845.2314453125,
        952.9754028320312
      ],
      "bbox_max": [
        -3203.56298828125,
        -4600.2314453125,
        1025.797607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.915094792842865,
        0.0502968430519104,
        -0.4000895023345947
      ],
      "plane_d": 3604.53076171875,
      "bbox_min": [
        -3244.62939453125,
        -4845.2314453125,
        952.9754028320312
      ],
      "bbox_max": [
        -3203.56298828125,
        -4600.2314453125,
        1025.797607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6410951614379883,
        -0.0957273319363594,
        0.7614677548408508
      ],
      "plane_d": 878.5167236328125,
      "bbox_min": [
        -3237.634765625,
        -4845.2314453125,
        952.9754028320312
      ],
      "bbox_max": [
        -3203.56298828125,
        -4600.2314453125,
        993.8011474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6454339027404785,
        -0.09527266025543213,
        0.7578510642051697
      ],
      "plane_d": -3259.11767578125,
      "bbox_min": [
        -3225.7265625,
        -4845.2314453125,
        952.9754028320312
      ],
      "bbox_max": [
        -3203.56298828125,
        -4600.2314453125,
        993.8011474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.12473246455192566,
        0.9921904802322388
      ],
      "plane_d": -1549.890869140625,
      "bbox_min": [
        -3225.7265625,
        -4845.2314453125,
        952.9754028320312
      ],
      "bbox_max": [
        -3215.3349609375,
        -4600.2314453125,
        983.775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36003994941711426,
        0.09283125400543213,
        -0.9283068776130676
      ],
      "plane_d": 2544.97802734375,
      "bbox_min": [
        -3244.62939453125,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3196.46875,
        -4400.2314453125,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3618845045566559,
        0.09276022017002106,
        -0.9275965094566345
      ],
      "plane_d": 218.925048828125,
      "bbox_min": [
        -3244.62939453125,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3196.46875,
        -4400.2314453125,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9134021997451782,
        0.040503934025764465,
        -0.40503811836242676
      ],
      "plane_d": -2324.3271484375,
      "bbox_min": [
        -3244.62939453125,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3196.46875,
        -4400.2314453125,
        1045.7977294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9134021997451782,
        -0.040503934025764465,
        0.40503811836242676
      ],
      "plane_d": -3514.996337890625,
      "bbox_min": [
        -3244.62939453125,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3196.46875,
        -4400.2314453125,
        1045.7977294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9155197739601135,
        -0.04002780839800835,
        0.4002768397331238
      ],
      "plane_d": 2382.18603515625,
      "bbox_min": [
        -3244.62939453125,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3203.56298828125,
        -4400.2314453125,
        1045.7977294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9155197739601135,
        0.040027931332588196,
        -0.4002768397331238
      ],
      "plane_d": 3558.859375,
      "bbox_min": [
        -3244.62939453125,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3203.56298828125,
        -4400.2314453125,
        1045.7977294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6421766877174377,
        -0.07627546787261963,
        0.7627524137496948
      ],
      "plane_d": 970.2244873046875,
      "bbox_min": [
        -3237.634765625,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3203.56298828125,
        -4400.2314453125,
        1013.8012084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6465123891830444,
        -0.0759115070104599,
        0.7591173052787781
      ],
      "plane_d": -3174.76513671875,
      "bbox_min": [
        -3225.7265625,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3203.56298828125,
        -4400.2314453125,
        1013.8012084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09950342029333115,
        0.9950372576713562
      ],
      "plane_d": -1436.6319580078125,
      "bbox_min": [
        -3225.7265625,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3215.3349609375,
        -4400.2314453125,
        1003.7753295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4300.0,
      "bbox_min": [
        -3244.62939453125,
        -4400.2314453125,
        1003.7753295898438
      ],
      "bbox_max": [
        -3094.0,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3616013824939728,
        0.0,
        -0.9323328733444214
      ],
      "plane_d": 2145.7646484375,
      "bbox_min": [
        -3244.62939453125,
        -4300.0,
        1003.7753295898438
      ],
      "bbox_max": [
        -3196.46875,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3634515106678009,
        0.0,
        -0.9316132068634033
      ],
      "plane_d": -190.060791015625,
      "bbox_min": [
        -3244.62939453125,
        -4300.0,
        1003.7753295898438
      ],
      "bbox_max": [
        -3196.46875,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.914152979850769,
        0.0,
        -0.40536949038505554
      ],
      "plane_d": -2504.612060546875,
      "bbox_min": [
        -3244.62939453125,
        -4300.0,
        1003.7753295898438
      ],
      "bbox_max": [
        -3196.46875,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9141523838043213,
        0.0,
        0.4053707718849182
      ],
      "plane_d": -3339.51025390625,
      "bbox_min": [
        -3244.62939453125,
        -4300.0,
        1003.7753295898438
      ],
      "bbox_max": [
        -3196.46875,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9162545204162598,
        0.0,
        -0.400596559047699
      ],
      "plane_d": 3385.4404296875,
      "bbox_min": [
        -3244.62939453125,
        -4300.0,
        1003.7753295898438
      ],
      "bbox_max": [
        -3196.46875,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9162540435791016,
        -0.0,
        0.4005979001522064
      ],
      "plane_d": 2560.369140625,
      "bbox_min": [
        -3244.62939453125,
        -4300.0,
        1003.7753295898438
      ],
      "bbox_max": [
        -3196.46875,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.64405757188797,
        -0.0,
        0.7649770975112915
      ],
      "plane_d": 1309.6885986328125,
      "bbox_min": [
        -3244.62939453125,
        -4300.0,
        1003.7753295898438
      ],
      "bbox_max": [
        -3196.46875,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6483878493309021,
        0.0,
        0.7613101601600647
      ],
      "plane_d": -2848.968505859375,
      "bbox_min": [
        -3244.62939453125,
        -4300.0,
        1003.7753295898438
      ],
      "bbox_max": [
        -3196.46875,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1003.7753295898438,
      "bbox_min": [
        -3244.62939453125,
        -4300.0,
        1003.7753295898438
      ],
      "bbox_max": [
        -3196.46875,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -4199.99951171875,
      "bbox_min": [
        -3244.62939453125,
        -4200.0,
        1003.7753295898438
      ],
      "bbox_max": [
        -3196.46875,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3180.0,
      "bbox_min": [
        -3244.62939453125,
        -4400.2314453125,
        1003.7753295898438
      ],
      "bbox_max": [
        -3094.0,
        -4300.0,
        1052.4244384765625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4367.96826171875,
      "bbox_min": [
        -3180.0,
        -4377.96875,
        1013.8012084960938
      ],
      "bbox_max": [
        -3104.0,
        -4367.96875,
        1051.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4377.96875,
      "bbox_min": [
        -3180.0,
        -4377.96875,
        1013.8012084960938
      ],
      "bbox_max": [
        -3104.0,
        -4367.96875,
        1051.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.32566747069358826,
        0.0,
        -0.9454843997955322
      ],
      "plane_d": 2004.575927734375,
      "bbox_min": [
        -3180.0,
        -4377.96875,
        1013.8012084960938
      ],
      "bbox_max": [
        -3104.0,
        -4367.96875,
        1051.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1026.199951171875,
      "bbox_min": [
        -3180.0,
        -4377.96875,
        1026.199951171875
      ],
      "bbox_max": [
        -3176.0,
        -4367.96875,
        1026.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32566678524017334,
        0.0,
        0.9454846978187561
      ],
      "plane_d": -1992.87255859375,
      "bbox_min": [
        -3180.0,
        -4377.96875,
        1013.8012084960938
      ],
      "bbox_max": [
        -3104.0,
        -4367.96875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.005645662546157837,
        0.0,
        0.9999841451644897
      ],
      "plane_d": -1031.7384033203125,
      "bbox_min": [
        -3180.0,
        -4377.96875,
        1013.8012084960938
      ],
      "bbox_max": [
        -3176.0,
        -4367.96875,
        1013.8237915039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3094.0,
      "bbox_min": [
        -3104.0,
        -4389.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3094.0,
        -4367.96875,
        1051.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1051.0,
      "bbox_min": [
        -3104.0,
        -4389.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3094.0,
        -4367.96875,
        1051.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4367.96875,
      "bbox_min": [
        -3104.0,
        -4367.96875,
        1038.623779296875
      ],
      "bbox_max": [
        -3094.0,
        -4367.96875,
        1051.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3616013526916504,
        0.0,
        -0.9323328137397766
      ],
      "plane_d": 2145.7646484375,
      "bbox_min": [
        -3244.62939453125,
        -4400.2314453125,
        1003.7753295898438
      ],
      "bbox_max": [
        -3203.56298828125,
        -4300.0,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3634514808654785,
        0.0,
        -0.9316131472587585
      ],
      "plane_d": -190.06072998046875,
      "bbox_min": [
        -3244.62939453125,
        -4400.2314453125,
        1003.7753295898438
      ],
      "bbox_max": [
        -3203.56298828125,
        -4300.0,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9162545800209045,
        0.0,
        -0.40059658885002136
      ],
      "plane_d": 3385.440673828125,
      "bbox_min": [
        -3244.62939453125,
        -4400.2314453125,
        1003.7753295898438
      ],
      "bbox_max": [
        -3203.56298828125,
        -4300.0,
        1045.7977294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9162539839744568,
        -0.0,
        0.40059787034988403
      ],
      "plane_d": 2560.369140625,
      "bbox_min": [
        -3244.62939453125,
        -4400.2314453125,
        1003.7753295898438
      ],
      "bbox_max": [
        -3203.56298828125,
        -4300.0,
        1029.7994384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6440575122833252,
        -0.0,
        0.7649770379066467
      ],
      "plane_d": 1309.6884765625,
      "bbox_min": [
        -3237.634765625,
        -4400.2314453125,
        1003.7753295898438
      ],
      "bbox_max": [
        -3203.56298828125,
        -4300.0,
        1013.8012084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1003.7753295898438,
      "bbox_min": [
        -3225.7265625,
        -4400.2314453125,
        1003.7753295898438
      ],
      "bbox_max": [
        -3203.56298828125,
        -4300.0,
        1013.8012084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6483878493309021,
        0.0,
        0.7613102197647095
      ],
      "plane_d": -2848.968505859375,
      "bbox_min": [
        -3215.3349609375,
        -4400.2314453125,
        1003.7753295898438
      ],
      "bbox_max": [
        -3203.56298828125,
        -4300.0,
        1013.8012084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1012.75,
      "bbox_min": [
        -3204.79736328125,
        -4340.0,
        1012.75
      ],
      "bbox_max": [
        -3203.56298828125,
        -4331.0,
        1013.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1013.75,
      "bbox_min": [
        -3204.79736328125,
        -4340.0,
        1012.75
      ],
      "bbox_max": [
        -3203.56298828125,
        -4331.0,
        1013.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4340.0,
      "bbox_min": [
        -3204.79736328125,
        -4340.0,
        1012.75
      ],
      "bbox_max": [
        -3203.56298828125,
        -4331.0,
        1013.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4331.0,
      "bbox_min": [
        -3204.79736328125,
        -4331.0,
        1012.75
      ],
      "bbox_max": [
        -3203.56298828125,
        -4331.0,
        1013.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1013.75,
      "bbox_min": [
        -3209.840087890625,
        -4340.0,
        1012.75
      ],
      "bbox_max": [
        -3203.622802734375,
        -4331.0,
        1013.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1012.75,
      "bbox_min": [
        -3209.840087890625,
        -4340.0,
        1012.75
      ],
      "bbox_max": [
        -3203.622802734375,
        -4331.0,
        1013.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3209.840087890625,
      "bbox_min": [
        -3209.840087890625,
        -4340.0,
        1012.75
      ],
      "bbox_max": [
        -3203.622802734375,
        -4331.0,
        1013.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4340.0,
      "bbox_min": [
        -3209.840087890625,
        -4340.0,
        1012.75
      ],
      "bbox_max": [
        -3203.622802734375,
        -4331.0,
        1013.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4331.0,
      "bbox_min": [
        -3209.840087890625,
        -4331.0,
        1012.75
      ],
      "bbox_max": [
        -3203.622802734375,
        -4331.0,
        1013.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42300987243652344,
        -0.0,
        -0.9061251878738403
      ],
      "plane_d": -407.51507568359375,
      "bbox_min": [
        -3203.56298828125,
        -4400.2314453125,
        1012.75
      ],
      "bbox_max": [
        -3180.0,
        -4300.0,
        1045.7977294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1013.8012084960938,
      "bbox_min": [
        -3203.56298828125,
        -4400.2314453125,
        1012.75
      ],
      "bbox_max": [
        -3180.0,
        -4300.0,
        1013.8012084960938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1013.75,
      "bbox_min": [
        -3203.56298828125,
        -4340.0,
        1012.75
      ],
      "bbox_max": [
        -3202.239990234375,
        -4331.0,
        1013.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1012.75,
      "bbox_min": [
        -3203.56298828125,
        -4340.0,
        1012.75
      ],
      "bbox_max": [
        -3202.239990234375,
        -4331.0,
        1013.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4340.0,
      "bbox_min": [
        -3203.56298828125,
        -4340.0,
        1012.75
      ],
      "bbox_max": [
        -3202.239990234375,
        -4331.0,
        1013.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4331.0,
      "bbox_min": [
        -3203.56298828125,
        -4331.0,
        1012.75
      ],
      "bbox_max": [
        -3202.239990234375,
        -4331.0,
        1013.75
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}